import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { CgArrowsExchange } from 'react-icons/cg'

import { Question } from '../../../api/services/orders/types.ts'
import { convertToShortDate } from '../../../utils/formatter.ts'

export const AnswerBoolean = ({
  question,
  horizontal = false
}: {
  question: Question
  horizontal?: boolean
}) => {
  const [changesExists, setChangesExists] = useState(false)
  const convertValueToDisplay = (value: boolean | null | undefined) =>
    value ? 'Tak' : 'Nie'
  const [showChanges, setShowChanges] = useState(false)
  const previousChange = question.answers[question.answers.length - 1].boolean_answer
  const [newestChange, setNewestChange] = useState<boolean | null | undefined>(
    null
  )

  useEffect(() => {
    question.answers.length > 1 ? setChangesExists(true) : null
  }, [question])

  useEffect(() => {
    if (changesExists) {
      const newestValue = question.answers.find(
        (answer) => answer.newest_change
      )?.boolean_answer
      setNewestChange(newestValue)
    }
  }, [changesExists, question])

  return (
    <ul
      key={question.id}
      className={classNames(
        horizontal
          ? 'text-[18px] py-2 pl-4 border-b dark:border-gray-700'
          : ' list-disc marker:text-gray-300 mb-4 pl-4'
      )}
    >
      <li
        className={classNames(
          horizontal
            ? 'flex flex-col md:flex-row items-start md:items-start gap-x-2'
            : 'pl-2'
        )}
      >
        <p
          className={classNames('dark:text-white',
            horizontal ? 'w-100 flex-shrink-0' : 'text-black-2 font-medium'
          )}
        >
          {question.text}
        </p>
        <div
          className={classNames(
            horizontal ? 'text-[18px] text-black-2 dark:text-white' : ''
          )}
        >
          {!horizontal &&
            typeof previousChange === 'boolean' &&
            convertValueToDisplay(previousChange)}

          {!showChanges && changesExists && !horizontal && (
            <div className={'flex flex-row gap-2 mt-2 items-center '}>
              <CgArrowsExchange className={'size-8'} color={'#87B725'} />
              <p className={'text-black-2 dark:text-white pr-4'}>
                Odpowiedź uległa zmianie
              </p>
              <button
                onClick={() => setShowChanges(true)}
                className={'border px-6 py-1 rounded-md'}
              >
                Sprawdź
              </button>
            </div>
          )}

          {showChanges && changesExists && !horizontal && (
            <div className={'bg-gray-100 dark:bg-gray-700 p-4 rounded-md mt-2'}>
              <p className={'text-black-2 dark:text-white'}>
                Pacjent zmienił odpowiedź
              </p>
              <ul>
                {question.answers.map((change, index) => {
                  if (index === question.answers.length - 1) return null
                  return (
                    <li
                      key={index}
                      className={
                        'flex flex-row gap-4 text-sm items-center border-b dark:border-b-gray-600 p-2'
                      }
                    >
                      <p>{convertToShortDate(change.created_at)}</p>
                      <div
                        className={`ml-6 w-2 h-2 rounded-full  ${index === 0 ? 'bg-[#87B725]' : 'bg-gray-300'}`}
                      ></div>

                      <p>{convertValueToDisplay(change.boolean_answer)}</p>
                    </li>
                  )
                })}
              </ul>
            </div>
          )}

          {horizontal && (
            <>
              <div
                className={classNames(
                  'text-[16px] text-black-2 dark:text-white',
                  changesExists ? 'line-through decoration-gray-500' : ''
                )}
              >
                {typeof previousChange === 'boolean' &&
                  convertValueToDisplay(previousChange)}
              </div>

              {changesExists && <div
                className={
                  'flex-1 bg-[#EAFFEC] dark:bg-gray-700 px-4 py-1 rounded-md mt-2'
                }
              >
                <p className={'py-1 font-bold text-[#508149] dark:text-white'}>
                  Aktualna odpowiedź
                </p>
                <div className={'text-[18px] text-[#508149] dark:text-white'}>
                  {newestChange && convertValueToDisplay(newestChange)}
                </div>
              </div>}
            </>
          )}
        </div>
      </li>
    </ul>
  )
}
